import { render, staticRenderFns } from "./recommendedProductDetails.vue?vue&type=template&id=7ad6998c&scoped=true"
import script from "./recommendedProductDetails.vue?vue&type=script&lang=js"
export * from "./recommendedProductDetails.vue?vue&type=script&lang=js"
import style0 from "./recommendedProductDetails.vue?vue&type=style&index=0&id=7ad6998c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad6998c",
  null
  
)

export default component.exports